// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".description-rtPYFKch {\n\tmargin-bottom: 1em;\n}\n\n.emailAddress-tzi7chym {\n\tfont-weight: bold;\n\tword-break: break-all;\n}\n\n.dropdown-\\+JqU1TFY {\n\twidth: 100%;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Content/Trials/EditTrial/SelectUserClientModal.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,WAAW;AACZ","sourcesContent":[".description {\n\tmargin-bottom: 1em;\n}\n\n.emailAddress {\n\tfont-weight: bold;\n\tword-break: break-all;\n}\n\n.dropdown {\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": "description-rtPYFKch",
	"emailAddress": "emailAddress-tzi7chym",
	"dropdown": "dropdown-+JqU1TFY"
};
export default ___CSS_LOADER_EXPORT___;
